export default __webpack_public_path__ + "static/media/Lens Logo Teal E.9be8a68e.svg";